export default "__VITE_ASSET__15f972e7__"